<template>
  <div>
    <a type="button" class="text-center text-dark text-decoration-none" data-bs-toggle="modal" data-bs-target="#helpModal"> 
      Having Problems?
     
    </a>

    <div class="modal" 
      id="helpModal"
      tabindex="-1"
      aria-labelledby="helpModalLabel"
      aria-hidden="true"
      >

      <div class="modal-dialog text-dark modal-lg">
        <div class="modal-content p-4">
          <h4 class="mb-4 text-center">Having Problems?</h4>
          <h5 class="text-center fw-bold">We are open during the following times:</h5>
          <div class="text-center">
          <div>
            <p class="fw-bold fs-6">Monday to Friday: 8am - 8pm</p>
            <p class="fw-bold fs-6">Saturday & Bank Holidays: 9am - 6pm</p>
            <p class="fw-bold fs-6">Sunday: 10am - 6pm</p>
          </div>
        </div>

        <div class="row mt-5">
          <div class="form-group-control col-12">
            <p class="fw-bold fs-6">Please call us on <strong>{{ defaultSite.telephone }}</strong> or use the form below and we will call you back as soon as possible.</p>
          </div>
        </div>

        <div class="mt-3">
          <form @submit.prevent="submitHelp">

            <!-- TITLE -->
            <label for="tile" class="fs-6">Title:</label>
            <div class="form-group mb-3">
              <select
                id="title"  
                class="form-select form-select-lg w-100"
                v-model="$v.form.title.$model"
                :state="validateState('title')"
              >
                <option v-for="(option, index) in titleOptions" :key="index" :value="option.value">{{ option.text }}</option>
                <!-- <b-form-invalid-feedback>This is a required field.</b-form-invalid-feedback> -->
                <div v-if="$v.form.title.$error" class="alert alert-danger fs-6">This is a required field.</div>
              </select>
            </div>

            <!-- FIRST NAME -->
            <div
              class="mt-3 form-group mb-3"
            > 
              <label for="firstName" class="fs-6">First Name:</label>
              <input
                class="form-control form-control-lg"
                id="firstName"
                v-model="$v.form.firstName.$model"
                type="text"
                placeholder="Enter First Name"
                :state="validateState('firstName')" />
                <!-- <b-form-invalid-feedback>This is a required field.</b-form-invalid-feedback> -->
                <div v-if="$v.form.firstName.$error" class="alert alert-danger fs-6">This is a required field.</div>
            </div>

            <!-- SURNAME-->
            <div
              class="form-group mb-3"
            >
              <label for="surname" class="fs-6">Surname:</label>
              <input
                class="form-control form-control-lg"
                id="surname"
                v-model.trim="$v.form.surname.$model"
                type="text"
                placeholder="Enter Surname"
                :state="validateState('surname')" />
              <!-- <b-form-invalid-feedback>This is a required field.</b-form-invalid-feedback> -->
              <div v-if="$v.form.surname.$error" class="alert alert-danger fs-6">This is a required field.</div>
            </div>

            <!-- PHONE NUMBER -->
            <div class="form-group mb-3"
            >
              <label for="phoneNumber" class="fs-6">Phone Number:</label>
              <input
                class="form-control form-control-lg"
                id="phoneNumber"
                v-model.trim="$v.form.phoneNumber.$model"
                type="number"
                placeholder="Enter Phone Number"
                :state="validateState('phoneNumber')" />
              <!-- <b-form-invalid-feedback>This is a required field.</b-form-invalid-feedback> -->
              <div v-if="$v.form.phoneNumber.$error" class="alert alert-danger fs-6">This is a required field.</div>
            </div>

          </form>

        </div>
        <div class="row">
        <div class="col-12 text-center">
          <div class="alert alert-success fs-6" v-if="successMessage" >Your submission has been sent.</div>
          <div class="alert alert-danger fs-6" v-if="errorMessage" >There was an error submitting your form.</div>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-success" @click="submitHelp">Submit</button>
        </div>
      </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postHelpForm } from '@/services/api.js'
import { required  } from 'vuelidate/lib/validators'

const { VUE_APP_HELP_MODAL_EMAIL_TO } = process.env
export default {
  props: ['defaultSite'],
  data() {
    return {
      form: {
        title: null,
        firstName: '',
        surname: '',
        phoneNumber: ''
      },
      titleOptions: [
        { text: 'Please Select', value: null },
        { text: 'Mr', value: 'Mr' },
        { text: 'Ms', value: 'Ms' },
        { text: 'Miss', value: 'Miss' },
        { text: 'Mrs', value: 'Mrs' },
        { text: 'Sir', value: 'Sir' },
        { text: 'Lady', value: 'Lady' },
        { text: 'Dr', value: 'Dr' } 
      ],
      successMessage: false,
      errorMessage: false,
      modalShow: false
    }
  },
  validations: {
    form: {
      title: { required },
      firstName: { required },
      surname: { required },
      phoneNumber: { required }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    hideModal() {
      this.modalShow = false
    },
    resetForm(){
      this.$v.$reset()
      this.form = {}
      this.form.title = null
      this.errorMessage = false
    },
    async submitHelp() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.errorMessage = true,
        this.successMessage = false
      } else {
        const email = {}
        email.subject = 'TF Insurance Web - Report a Problem form submission'
        email.send_to = VUE_APP_HELP_MODAL_EMAIL_TO
        email.email_body =
        '<div>Hi, <br><br>The following details have been submitted by a client having problems using the Trailfinders Travel Insurance website:' +
        '<br><br>Title: <strong>' +
        this.form.title +
        '</strong>' +
        '<br>Name: <strong>' +
        this.form.firstName +
        ' ' +
        this.form.surname +
        '</strong>' +
        '<br>Telephone: <strong>' +
        this.form.phoneNumber +
        '</strong>' +
        '<br><br>Please contact the client ASAP.' +
        '<br><br>Thank you.' +
        '</div>'
        email.originator_system = 'insurance'

        let res = await postHelpForm(email)
          if (!res.error) {
            this.successMessage = true,
            this.errorMessage = false
            setTimeout(() => {
              this.form.title =  '' ,
              this.form.firstName =  '' ,
              this.form.surname =  '' ,
              this.form.phoneNumber =  ''
              this.successMessage = false,
              this.modalShow = false
            }, 2000)
          } else {
            this.successMessage = false,
            this.errorMessage = true
          }
      }
    },
  }
}

</script>
<style scoped>
 
</style>